import './default.scss';
import title from './assets/component/title';
import main from './assets/component/main';
import solution from './assets/component/solution';
import rotateLetters from "./assets/function/rotateLetters";
import displayQuestion from "./assets/function/displayQuestion";
import checkResult from "./assets/function/checkResult";

const app = document.querySelector('#app');
let content = '';
content += title();
content += main();
content += solution();
app.innerHTML= content;
const letters = [ document.querySelector('.solution_letter1'), document.querySelector('.solution_letter2'), document.querySelector('.solution_letter3'), document.querySelector('.solution_letter4'), document.querySelector('.solution_letter5'), document.querySelector('.solution_letter6'), document.querySelector('.solution_letter7'), document.querySelector('.solution_letter8') ];
const mainText = document.querySelector('.main_text');
const mainInput = document.querySelector('.main_input');
displayQuestion();
rotateLetters();

mainInput.addEventListener( 'input' , () => { checkResult() });

export { letters, mainText, mainInput };